import script from "./Notifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./Notifications.vue?vue&type=script&setup=true&lang=ts"

import "./Notifications.vue?vue&type=style&index=0&id=3fe86cb4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\digi_aj\\source\\repos\\1ANAB_Vue_Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fe86cb4"]])

export default __exports__